export const types = {
  header: 'header',
  normal: 'normal',
  bullet: 'bullet',
};

export const data = [
  {
    type: types.normal,
    text: 'Updated on 28/6/2021',
  },
  {
    type: types.normal,
    text:
      '\nThis Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.\nWe use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.',
  },
  {type: types.header, text: 'Interpretation and Definitions'},
  {type: types.header, text: 'Interpretation'},
  {
    type: types.normal,
    text:
      'The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.',
  },
  {type: types.header, text: 'Definitions'},
  {type: types.normal, text: 'For the purposes of this Privacy Policy:'},
  {
    type: types.bullet,
    text:
      '- Account means a unique account created for You to access our Service or parts of our Service.',
  },
  {
    type: types.bullet,
    text:
      '- Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.',
  },
  {
    type: types.bullet,
    text:
      '- Application means the software program provided by the Company downloaded by You on any electronic device, named STAR TUTOR',
  },
  {
    type: types.bullet,
    text:
      '- Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to STAR TUTOR SDN BHD, 3-9-7, Residensi Alami, Jalan Tinju 13/50, Seksyen 13.',
  },
  {type: types.bullet, text: '- Country refers to: Malaysia'},
  {
    type: types.bullet,
    text:
      '- Device means any device that can access the Service such as a computer, a smart phone or a digital tablet.',
  },
  {
    type: types.bullet,
    text:
      '- Personal Data is any information that relates to an identified or identifiable individual.',
  },
  {type: types.bullet, text: '- Service refers to the Application.'},
  {
    type: types.bullet,
    text:
      '- Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.',
  },
  {
    type: types.bullet,
    text:
      '- Third-party Social Media Service refers to any website or any social network website through which a User can log in or create an account to use the Service.',
  },
  {
    type: types.bullet,
    text:
      '- Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).',
  },
  {
    type: types.bullet,
    text:
      '- You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
  },
  {type: types.header, text: 'Collecting and Using Your Personal Data'},
  {type: types.header, text: 'Types of Data Collected'},
  {type: types.header, text: 'Personal Data'},
  {
    type: types.normal,
    text:
      'While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:',
  },
  {type: types.bullet, text: '- Email address'},
  {type: types.bullet, text: '- First name and last name'},
  {type: types.bullet, text: '- Phone number'},
  {type: types.bullet, text: '- Identification card number'},
  {
    type: types.bullet,
    text: '- Address, State, Province, ZIP/Postal code, City',
  },
  {type: types.bullet, text: '- Usage Data'},
  {type: types.header, text: 'Usage Data'},
  {
    type: types.normal,
    text: 'Usage Data is collected automatically when using the Service.',
  },
  {
    type: types.normal,
    text:
      "Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.",
  },
  {
    type: types.normal,
    text:
      'When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.',
  },
  {
    type: types.normal,
    text:
      'We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.',
  },
  {
    type: types.header,
    text: 'Information from Third-Party Social Media Services',
  },
  {
    type: types.normal,
    text:
      'The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:',
  },
  {type: types.bullet, text: '- Google'},
  {type: types.bullet, text: '- Facebook'},
  {type: types.bullet, text: '- Twitter'},
  {
    type: types.normal,
    text:
      "If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect Personal data that is already associated with Your Third-Party Social Media Service's account, such as Your name, Your email address, Your activities or Your contact list associated with that account.",
  },
  {
    type: types.normal,
    text:
      "You may also have the option of sharing additional information with the Company through Your Third-Party Social Media Service's account. If You choose to provide such information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this Privacy Policy.",
  },
  {type: types.header, text: 'Use of Your Personal Data'},
  {
    type: types.header,
    text: 'The Company may use Personal Data for the following purposes:',
  },
  {
    type: types.bullet,
    text:
      '- To provide and maintain our Service, including to monitor the usage of our Service.',
  },
  {
    type: types.bullet,
    text:
      'To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.',
  },
  {
    type: types.bullet,
    text:
      'For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.',
  },
  {
    type: types.bullet,
    text:
      "To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.",
  },
  {
    type: types.bullet,
    text:
      'To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.',
  },
  {
    type: types.bullet,
    text: 'To manage Your requests: To attend and manage Your requests to Us.',
  },
  {
    type: types.bullet,
    text:
      'For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.',
  },
  {
    type: types.bullet,
    text:
      'For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.',
  },
  {
    type: types.normal,
    text: 'We may share Your personal information in the following situations:',
  },
  {type: types.normal, text: 'With Service Providers:'},
  {
    type: types.normal,
    text:
      'We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.',
  },
  {
    type: types.bullet,
    text:
      'For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.',
  },
  {
    type: types.bullet,
    text:
      'With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.',
  },
  {
    type: types.bullet,
    text:
      'With business partners: We may share Your information with Our business partners to offer You certain products, services or promotions.',
  },
  {
    type: types.bullet,
    text:
      'With other users: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile.',
  },
  {
    type: types.bullet,
    text:
      'With Your consent: We may disclose Your personal information for any other purpose with Your consent.',
  },
  {type: types.header, text: 'Retention of Your Personal Data'},
  {
    type: types.normal,
    text:
      'The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.',
  },
  {
    type: types.normal,
    text:
      'The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.',
  },
  {type: types.header, text: 'Transfer of Your Personal Data'},
  {
    type: types.normal,
    text:
      "Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.",
  },
  {
    type: types.normal,
    text:
      'Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.',
  },
  {
    type: types.normal,
    text:
      'The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.',
  },
  {type: types.header, text: 'Disclosure of Your Personal Data'},
  {type: types.header, text: 'Business Transactions'},
  {
    type: types.normal,
    text:
      'If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.',
  },
  {type: types.header, text: 'Law enforcement'},
  {
    type: types.normal,
    text:
      'Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).',
  },
  {type: types.header, text: 'Other legal requirements'},
  {
    type: types.normal,
    text:
      'The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:',
  },
  {type: types.bullet, text: '- Comply with a legal obligation'},
  {
    type: types.bullet,
    text: '- Protect and defend the rights or property of the Company',
  },
  {
    type: types.bullet,
    text:
      '- Prevent or investigate possible wrongdoing in connection with the Service',
  },
  {
    type: types.bullet,
    text: '- Protect the personal safety of Users of the Service or the public',
  },
  {type: types.bullet, text: '- Protect against legal liability'},
  {type: types.header, text: 'Security of Your Personal Data'},
  {
    type: types.normal,
    text:
      'The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.',
  },
  {type: types.header, text: 'Links to Other Websites'},
  {
    type: types.normal,
    text:
      "Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.",
  },
  {
    type: types.normal,
    text:
      'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.',
  },
  {type: types.header, text: 'Changes to this Privacy Policy'},
  {
    type: types.normal,
    text:
      'We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.',
  },
  {
    type: types.normal,
    text:
      'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.',
  },
  {
    type: types.normal,
    text:
      'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
  },
  {type: types.header, text: 'Contact Us'},
  {
    type: types.normal,
    text:
      'If you have any questions about this Privacy Policy, You can contact us:',
  },
  {type: types.normal, text: 'By phone number: 019 955 9941 or 014 848 9941'},
];
